import styled from 'styled-components'

const COCKPIT_SIDEBAR_BORDER = '#dde5ed'
const COCKPIT_CAPTION_SWATCH_BORDER = '#006bff'

export const GanttCockpitRoadmapRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  min-width: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    flex-direction: column;
  }
`

export const GanttCockpitRoadmapSidebar = styled.aside`
  width: 280px;
  min-width: 280px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${COCKPIT_SIDEBAR_BORDER};

  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    width: 100%;
    min-width: 0;
    border-right: none;
    border-bottom: 1px solid ${COCKPIT_SIDEBAR_BORDER};
    padding-bottom: 20px;
  }
`

export const GanttCockpitRoadmapChartColumn = styled.div`
  flex: 1;
  min-width: 0;
  padding: 16px 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    width: 100%;
    padding-top: 16px;
  }
`

export const MilestoneBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
`

export const MilestoneTitleLine = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: baseline;
  overflow-x: auto;
  scrollbar-width: thin;

  &,
  & * {
    white-space: nowrap;
  }
`

export const CaptionsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const CaptionLegendRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const CaptionSwatch = styled.span<{ $color: string }>`
  width: 16px;
  height: 16px;
  min-width: 16px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${({ $color }) => $color};
  border: 1px solid ${COCKPIT_CAPTION_SWATCH_BORDER};
`
